export default {
  apiKey: 'AIzaSyCc_a8ngNygpHTrxLY01L2BoqhyK4pnQAs',
};
